import useProject from '@hooks/useProject';
import {
    getIsPrepaidCardBalanceUpdated,
    setIsPrepaidCardBalanceUpdated,
} from '@utils/prepaidCardUtils';
import { useEffect, useState } from 'react';

// KICC 선불카드가 약 2초 후에 갱신되기에 조건을 맞춘다
function usePrepaidCardFetchEnabled() {
    const project = useProject();
    const topUpVendor = project?.topUpVendor;
    const [fetchEnabled, setFetchEnabled] = useState<boolean>(false);
    useEffect(() => {
        if (topUpVendor === 'KIS') {
            setFetchEnabled(true);
        }
        if (topUpVendor === 'KICC') {
            const shouldWait = getIsPrepaidCardBalanceUpdated();
            if (shouldWait) {
                const timeout = setTimeout(() => {
                    setIsPrepaidCardBalanceUpdated(false);
                    setFetchEnabled(true);
                }, 2000);
                return () => clearTimeout(timeout);
            }
            setFetchEnabled(true);
        }
        return () => {};
    }, [topUpVendor]);

    return fetchEnabled;
}

export default usePrepaidCardFetchEnabled;
